export default ({ i18n }, inject) => {
  /**
   * @param {'email' | 'rut' | 'firstName' | 'lastName' | 'address'} type
   */
  const getTranslatedLabel = (type) => {
    return i18n.t(`label.${type}`)
  }

  /**
   * @param {'email' | 'rut' | 'firstName' | 'lastName' | 'address'} type
   */
  const getTranslatedPlaceholder = (type) => {
    return i18n.t(`placeHolder.${type}`)
  }

  const forms = { getTranslatedLabel, getTranslatedPlaceholder }

  // Inyectar en el contexto de Vue
  inject('forms', forms)
}
